import Route from 'cio/routes/base';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';

import FiltersService from 'cio/services/filters';
import SegmentModel from 'cio/models/segment';
import AudienceModel from 'cio/models/audience';
import SegmentsIndexController from './controller';

import Transition from '@ember/routing/-private/transition';
import ArrayProxy from '@ember/array/proxy';
import DS from 'ember-data';

export default class IndexRoute extends Route {
  @service filters!: FiltersService;
  @service store!: DS.Store;

  queryParams = {
    search: {
      replace: true,
    },
    searchTagIds: {
      replace: true,
    },
    objectTypeIds: {
      replace: true,
    },
  };

  async model() {
    return hash({
      // We use "query" here instead of "findAll" to ensure that the latest records are always grabbed
      segments: this.store.query('segment', {}),
      audiences: this.store.findAll('audience'),
      objectTypes: this.store.peekAll('object-type'),
      tags: this.store.peekAll('tag'),
    });
  }

  afterModel() {
    return this.filters.process.perform();
  }

  setupController(
    controller: SegmentsIndexController,
    model: { segments: ArrayProxy<SegmentModel>; audiences: ArrayProxy<AudienceModel> },
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);
    controller.resetSelectedSegments();
  }

  @action
  refreshModel() {
    this.refresh();
  }
}
